import {required, requiredIf, minValue, maxValue} from 'vuelidate/lib/validators'
import { notOlderThanTwoYears, notFutureDate} from "@/validations/date-validation";

const requiredIfPregnant = requiredIf((vm) => {
  return vm.isPregnancy === true;
});

const requiredIfPCOS = requiredIf((vm) => {
  return vm.pcosHistory === true;
});

const requiredIfAbortion = requiredIf((vm) => {
  return vm.isPregnancy === true && vm.pregnancyType === 3;
});

const requiredIfEctopic = requiredIf((vm) => {
  return vm.isPregnancy === true && vm.pregnancyType === 4;
});

const requiredIfMultiple = requiredIf((vm) => {
  return vm.isPregnancy === true && vm.pregnancyType === 2;
});

const requiredIfMolar = requiredIf((vm) => {
  return vm.isPregnancy === true && vm.pregnancyType === 5;
});

const requiredIfPregnantAndIsDelivered = requiredIf((vm) => {
  return vm.isPregnancy === true && vm.isDelivered;
});

const requiredIfPregnantAndExact = requiredIf((vm) => {
  return vm.isPregnancy === true && vm.admissionAOGType === 1;
});

const requiredIfComplicated = requiredIf((vm) => {
  return vm.complicatedPregnancy === true
});


export default {
  admissionDate: {
    required,
    notFuture: notFutureDate,
    notTooOld: notOlderThanTwoYears,
  },
  age: {
    required
  },
  weight: {
    required
  },
  height: {
    required
  },
  bmi: {
    required
  },
  caseFormType: {
    required
  },
  complicatedPregnancy: {
    requiredIf : requiredIfPregnant
  },
  pcosHistory: {
    required
  },
  pcosSymptoms: {
    requiredIf: requiredIfPCOS
  },
  isPostpartum: {
    requiredIf: requiredIfPregnant
  },
  returnToOR: {
    requiredIf: requiredIfComplicated
  },
  admissionAOG: {
    requiredIf : requiredIfPregnant
  },
  admissionWeeks: {
    requiredIf : requiredIfPregnantAndExact
  },
  admissionDays: {
    requiredIf : requiredIfPregnantAndExact
  },
  pregnancyType: {
    requiredIf : requiredIfPregnant
  },
  isHeterotopic: {
    requiredIf : requiredIfMultiple
  },
  abortionType: {
    requiredIf : requiredIfAbortion
  },
  ectopicType: {
    requiredIf : requiredIfEctopic
  },
  molarType: {
    requiredIf : requiredIfMolar
  },
  institutionalDelivery: {
    requiredIf : requiredIfPregnantAndIsDelivered
  },
}
